import * as t from '../actionTypes'
import axios from 'utils/axios'
import { guardFromErrors, extractErrorInfo } from 'utils/graphqlHelpers'
import { ProductSize } from '../types'

type ProductColorList = {
  items: ProductSize[]
  total: number
}

type Payload = ProductColorList & {
  page: number
}

export type FetchProductSizesListAction = FSA<undefined, Payload, string>
type FetchProductSizesList = () => MrxThunk<FetchProductSizesListAction>
type QueryResponse = GraphQLResponse<'productSizesList', ProductColorList>

const FETCH_PRODUCT_SIZES_LIST = `
  query fetchProductSizesList($page: Int, $size: Int, $filters: ProductSizesFilters!) {
    productSizesList(page: $page, size: $size, filters: $filters) {
      items {
        id
        workspaceId
        name
        displayName
        createdAt
        updatedAt
      },
      total
    }
  }
`

const fetchProductSizesList: FetchProductSizesList = () => async (dispatch, getState) => {
  dispatch({
    type: t.FETCH_PRODUCT_SIZES_LIST,
    meta: { done: false }
  })

  try {
    const {
      workspaces: {
        activeWorkspace: { id: workspaceId }
      },
      productSizes: {
        pagination: { currentPage: page, size }
      }
    } = getState()
    const {
      data: { data, errors }
    }: QueryResponse = await axios.post('/graphql', {
      query: FETCH_PRODUCT_SIZES_LIST,
      variables: { page, size, filters: { workspaceId } }
    })

    guardFromErrors(errors)

    if (!data) {
      throw new Error('Response body is empty!')
    }

    const { productSizesList } = data
    if (!productSizesList) {
      throw new Error("Can't get product sizes list page!")
    }

    dispatch({
      type: t.FETCH_PRODUCT_SIZES_LIST,
      payload: {
        page,
        total: productSizesList.total,
        items: productSizesList.items
      },
      meta: { done: true }
    })
  } catch (err) {
    dispatch({
      type: t.FETCH_PRODUCT_SIZES_LIST,
      payload: extractErrorInfo(err),
      error: true
    })
  }
}

export { fetchProductSizesList }
